export const COMPANY_INFO = {
  name: "CMSNord.dk",
  previousName: "Christians Maskin Service",
  address: "Sdr. Omfartsvej 322",
  zipCity: "9700 Brønderslev",
  fullAddress: "Sdr. Omfartsvej 322, 9700 Brønderslev",
  phone: "25 62 35 05",
  phoneRaw: "25623505",
  email: "kontakt@cmsnord.dk",
  cvr: "43233629",
  hours: "Mandag - Fredag: 07.00 - 16.30 | Lørdag: 09.00 - 15.00 | Søndag: Lukket",
  slogan: "Huller & Haver - Er noget af det vi laver!",
  locationMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2159.0888902517865!2d9.9328221!3d57.2608405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46493b8e4e76a6b5%3A0x6b19a32c694a11b0!2sSdr.%20Omfartsvej%20322%2C%209700%20Br%C3%B8nderslev!5e0!3m2!1sda!2sdk!4v1700000000000!5m2!1sda!2sdk",
  facebookPage: "https://www.facebook.com/ChristiansMaskinService/",
  facebookReviews: "https://www.facebook.com/ChristiansMaskinService/reviews?locale=da_DK",
  trustpilotReviews: "https://dk.trustpilot.com/review/christiansmaskinservice.dk"
};

export const CORE_VALUES = [
  {
    title: "Alsidig og hårdtarbejdende",
    desc: "Jeg yder 100% på alle opgaver",
    icon: "fa-solid fa-screwdriver-wrench"
  },
  {
    title: "Fleksibel og hurtig",
    desc: "Jeg går langt for dig, også i weekenden!",
    icon: "fa-solid fa-clock-rotate-left"
  },
  {
    title: "Egne maskiner",
    desc: "Jeg har de rigtige værktøjer til opgaven",
    icon: "fa-solid fa-truck-pickup"
  }
];

export const SERVICES = [
  {
    id: "entreprenoer",
    slug: "entreprenoer",
    title: "Entreprenørarbejde",
    category: "Entreprenør",
    iconClass: "fa-solid fa-trowel-bricks",
    shortDesc: "Graving, jordarbejde, udstykninger og professionelt entreprenørarbejde udført med moderne maskinpark.",
    primaryImage: "",
    gallerySlug: "jordarbejde",
    body: `
      <h2><strong>Professionelt entreprenørarbejde i Brønderslev & Nordjylland</strong></h2>
      <p>Hos <strong>CMSNord.dk</strong> leverer vi solidt, pålideligt og effektivt entreprenørarbejde til både private boligejere, landbrug og erhvervsvirksomheder. Med udgangspunkt i Brønderslev rykker vi hurtigt ud til opgaver i hele Vendsyssel, Hjørring, Aalborg og omegn.</p>
      
      <p>Uanset om du skal i gang med et nybyggeri, renovering af udendørsarealer, anlæggelse af ny indkørsel eller nedrivning af udtjente bygninger, råder vi over den rette maskinpark og erfaring til at bringe projektet sikkert i mål – til aftalt tid og fast pris.</p>

      <h2><strong>Vores primære entreprenørydelser</strong></h2>
      <p>Vi dækker to stærke hovedområder inden for entreprenørfaget. Klik ind på undersiderne herunder for at læse mere om de enkelte ydelser:</p>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 not-prose my-8">
        <!-- Jord & Gravearbejde Card -->
        <a href="/ydelser/gravearbejde" class="group block p-6 bg-white hover:bg-zinc-50 border border-zinc-200 hover:border-[#F4AF00] rounded-xl transition-all shadow-sm hover:shadow-md">
          <div class="flex items-center justify-between mb-4">
            <div class="w-12 h-12 rounded-xl bg-[#F4AF00] text-[#121212] flex items-center justify-center text-xl font-bold">
              <i class="fa-solid fa-trowel" aria-hidden="true"></i>
            </div>
            <span class="text-xs font-bold uppercase tracking-wider text-zinc-500 bg-zinc-100 px-2.5 py-1 rounded-md group-hover:bg-[#F4AF00]/20 group-hover:text-[#121212] transition-colors">
              Læs mere &rarr;
            </span>
          </div>
          <h3 class="text-lg font-bold text-[#121212] mb-2 group-hover:text-[#121212]">
            Jord- & Gravearbejde
          </h3>
          <p class="text-sm text-zinc-600 leading-relaxed mb-4">
            Præcisionsudgravning til fundamenter, rørledninger, kabler, terrasser, indkørsler samt nivellering og planering af terræn.
          </p>
          <ul class="text-xs text-zinc-500 space-y-1.5 border-t border-zinc-100 pt-3">
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Udgravning til nybyg & tilbyg</li>
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Rende- og kabelgravning</li>
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Terrænregulering og jordflytning</li>
          </ul>
        </a>

        <!-- Nedbrydning Card -->
        <a href="/ydelser/nedbrydning" class="group block p-6 bg-white hover:bg-zinc-50 border border-zinc-200 hover:border-[#F4AF00] rounded-xl transition-all shadow-sm hover:shadow-md">
          <div class="flex items-center justify-between mb-4">
            <div class="w-12 h-12 rounded-xl bg-[#121212] text-[#F4AF00] flex items-center justify-center text-xl font-bold">
              <i class="fa-solid fa-hammer" aria-hidden="true"></i>
            </div>
            <span class="text-xs font-bold uppercase tracking-wider text-zinc-500 bg-zinc-100 px-2.5 py-1 rounded-md group-hover:bg-[#F4AF00]/20 group-hover:text-[#121212] transition-colors">
              Læs mere &rarr;
            </span>
          </div>
          <h3 class="text-lg font-bold text-[#121212] mb-2 group-hover:text-[#121212]">
            Nedbrydning
          </h3>
          <p class="text-sm text-zinc-600 leading-relaxed mb-4">
            Kontrolleret og sikker nedbrydning af mindre bygninger, udhuse, carporte, betonsokler og gulve med miljøforsvarlig affaldshåndtering.
          </p>
          <ul class="text-xs text-zinc-500 space-y-1.5 border-t border-zinc-100 pt-3">
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Nedrivning af skure, garager & carporte</li>
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Opbrydning af sokler og betonlag</li>
            <li class="flex items-center gap-2"><i class="fa-solid fa-check text-[#F4AF00]"></i> Total bortkørsel og affaldssortering</li>
          </ul>
        </a>
      </div>

      <h2><strong>Hvorfor vælge CMSNord som din entreprenør?</strong></h2>
      <p>Når du samarbejder med CMSNord, slipper du for fordyrende mellemled og usikre aftaler. Vi råder over egne maskiner og sørger for en smidig proces fra start til slut:</p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 not-prose my-6">
        <div class="p-5 bg-zinc-50 border border-zinc-200 rounded-xl">
          <div class="w-8 h-8 rounded-lg bg-[#F4AF00]/20 text-[#121212] flex items-center justify-center font-bold text-sm mb-3">
            <i class="fa-solid fa-truck-ramp-box"></i>
          </div>
          <h4 class="font-bold text-[#121212] text-sm mb-1">Egen maskinpark</h4>
          <p class="text-xs text-zinc-600 leading-relaxed">
            Moderne minigravere, dumpere og udstyr, der kommer til selv ved trange adgangsforhold.
          </p>
        </div>

        <div class="p-5 bg-zinc-50 border border-zinc-200 rounded-xl">
          <div class="w-8 h-8 rounded-lg bg-[#F4AF00]/20 text-[#121212] flex items-center justify-center font-bold text-sm mb-3">
            <i class="fa-solid fa-file-invoice-dollar"></i>
          </div>
          <h4 class="font-bold text-[#121212] text-sm mb-1">Gennemsigtige priser</h4>
          <p class="text-xs text-zinc-600 leading-relaxed">
            Klare tilbud og faste rammer uden ubehagelige overraskelser eller skjulte gebyrer.
          </p>
        </div>

        <div class="p-5 bg-zinc-50 border border-zinc-200 rounded-xl">
          <div class="w-8 h-8 rounded-lg bg-[#F4AF00]/20 text-[#121212] flex items-center justify-center font-bold text-sm mb-3">
            <i class="fa-solid fa-handshake-angle"></i>
          </div>
          <h4 class="font-bold text-[#121212] text-sm mb-1">Komplet totalløsning</h4>
          <p class="text-xs text-zinc-600 leading-relaxed">
            Kombiner gravearbejde med vores vognmandskørsel, bortskaffelse og belægning i én samlet aftale.
          </p>
        </div>
      </div>
    `,
    metaTitle: "Entreprenørarbejde i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Erfaren entreprenør i Brønderslev. Vi udfører jord- og gravearbejde, nedbrydning, belægning og vognmandskørsel i hele Nordjylland."
  },
  {
    id: "gravearbejde",
    slug: "gravearbejde",
    title: "Jord- & Gravearbejde",
    category: "Entreprenør",
    iconClass: "fa-solid fa-trowel",
    shortDesc: "Overlad gravearbejdet til os. Professionelle graveydelser, udgravning, jordnivellering og skræddersyede anlægsprojekter.",
    primaryImage: "",
    gallerySlug: "jordarbejde",
    body: `
      <h2><strong>Overlad gravearbejdet til os</strong></h2>
      <p>Vi er din erfarne gravepartner i Nordjylland, der tilbyder præcist arbejde til konkurrencedygtige priser. Vores hold leverer professionelle graveydelser, herunder præcisionsudgravning, jordnivellering og skræddersyede anlægsprojekter.</p>
      <p>Vi har fokus på nøjagtighed, pålidelighed, effektivitet og gennemtænkte løsninger, så du altid står tilbage med et solidt og holdbart resultat.</p>

      <h2><strong>Vi ordner dit gravearbejde</strong></h2>
      <p>Har du brug for en erfaren samarbejdspartner til dit jord- og gravearbejde i Nordjylland, skal du ikke lede videre. Vi udfører alt fra mindre udgravninger på villagrunde til større entreprenøropgaver for erhverv og landbrug.</p>

      <h2><strong>Præcision og ekspertise i gravearbejde</strong></h2>
      <p>Med vores moderne maskinpark af minigravere og dumpere sikrer vi hurtig og skånsom udførelse – også hvor pladsen er trang. Vores primære fokusområder dækker:</p>
      <ul>
        <li><strong>Nøjagtig og professionel udførelse:</strong> Grundig laseropmåling og korrekt fald.</li>
        <li><strong>Konkurrencedygtige priser:</strong> Faste aftaler og gennemskuelige tilbud.</li>
        <li><strong>Pålidelig og fleksibel service:</strong> Hurtig udrykning og overholdelse af tidsplaner.</li>
        <li><strong>Skræddersyede løsninger:</strong> Tilpasset præcis dine specifikke projektkrav.</li>
      </ul>
      <p>Vi udfører blandt andet kabel- og rørgravning, udgravning til indkørsler, terrasser, støttemure, fundamenter samt nedgravning af trampoliner og regnvandsfaskiner.</p>
    `,
    metaTitle: "Jord- & Gravearbejde i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Professionelt gravearbejde og jordarbejde i Brønderslev, Aalborg og Hjørring. Præcision, egne maskiner og konkurrencedygtige priser."
  },
  {
    id: "nedbrydning",
    slug: "nedbrydning",
    title: "Nedbrydning",
    category: "Entreprenør",
    iconClass: "fa-solid fa-hammer",
    shortDesc: "Nedbrydning af høj effektivitet. Sikker nedbrydning af mindre bygninger, sokler, betonlag og affaldsbortskaffelse.",
    primaryImage: "",
    gallerySlug: "nedbrydning",
    body: `
      <h2><strong>Nedbrydning af høj effektivitet</strong></h2>
      <p>Vores dygtige team udfører nøjagtig og sikker nedbrydning med fokus på effektiv bortskaffelse af byggematerialer og affald. Vi følger de højeste sikkerhedsstandarder for at beskytte både vores personale og omgivelserne.</p>

      <h2><strong>Sikker og kontrolleret nedbrydning</strong></h2>
      <p>Vi er din erfarne partner, når det kommer til nedbrydning af mindre bygninger, sokler, betonlag, carporte og skure. Vi er specialister i håndtering af nedrivningsopgaver i hele Nordjylland, uanset om det drejer sig om renovering, ombygning eller fjernelse af strukturer, der ikke længere tjener et formål.</p>

      <h2><strong>Hvorfor vælge CMSNord?</strong></h2>
      <ul>
        <li><strong>Erfaring og ekspertise i nedbrydning:</strong> Sikkert arbejde med minigraver og specialudstyr.</li>
        <li><strong>Effektiv og pålidelig service:</strong> Vi rydder grunden og efterlader den klar til nyt byggeri.</li>
        <li><strong>Konkurrencedygtige priser:</strong> Gennemskuelige tilbud uden skjulte ekstraregninger.</li>
        <li><strong>Miljøbevidst bortskaffelse:</strong> Sortering og bortkørsel af murbrokker, beton, træ og jern i egne containere.</li>
      </ul>
      <p>Vi kan uden problemer tage os af din nedbrydningsopgave og sikre, at den udføres professionelt og problemfrit.</p>
    `,
    metaTitle: "Nedbrydning i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Sikker og effektiv nedbrydning af mindre bygninger, betonlag og sokler. Miljørigtig bortskaffelse i Brønderslev og Nordjylland."
  },
  {
    id: "belaegning",
    slug: "belaegning",
    title: "Belægnings arbejde",
    category: "Belægning & Have",
    iconClass: "fa-solid fa-cubes",
    shortDesc: "Mangler du en erfaren brolægger i Brønderslev og Nordjylland? Vi skaber smukke og holdbare terrasser, indkørsler, gangstier og støttemure.",
    primaryImage: "",
    gallerySlug: "belaegning",
    body: `
      <h2><strong>Belægningsarbejde i Brønderslev & omegn</strong></h2>
      <p>Søger du en erfaren brolægger i Brønderslev og Nordjylland? Vi skaber smukke og langtidsholdbare udendørs belægninger til både private og erhverv – altid med fokus på kvalitet, korrekt underlag og konkurrencedygtige priser.</p>

      <h2><strong>Vores opgaver inden for belægning</strong></h2>
      <p>Vi varetager hele processen fra udgravning og bærelag til selve fliselægningen og den afsluttende fugning:</p>
      <ul>
        <li><strong>Indkørsler:</strong> Bæredygtige og solide belægninger tilpasset daglig biltrafik.</li>
        <li><strong>Terrasser & gårdhaver:</strong> Indbydende uderum i betonfliser, klinker eller natursten.</li>
        <li><strong>Gangstier & adgangsveje:</strong> Flotte og funktionelle stier i haven og omkring bygningen.</li>
        <li><strong>Støttemure & trappetrin:</strong> Elegante niveauskift og stabil terrænregulering.</li>
        <li><strong>Parkeringsarealer:</strong> Holdbare løsninger til erhverv og boligforeninger.</li>
      </ul>

      <h2><strong>Valg af fliser & materialer</strong></h2>
      <p>Et flot og holdbart resultat kræver det rette forarbejde og de rigtige materialer. Vi rådgiver gerne om de bedste løsninger:</p>
      <ul>
        <li><strong>Betonfliser:</strong> Klassiske, alsidige og slidstærke til både terrasser og indkørsler.</li>
        <li><strong>Natursten & granit:</strong> Eksklusivt og tidløst udtryk med maksimal levetid.</li>
        <li><strong>Keramiske fliser:</strong> Høj modstandsdygtighed over for frost og alger med minimal vedligeholdelse.</li>
        <li><strong>Klinker:</strong> Varme nuancer og stærk holdbarhed.</li>
        <li><strong>Permeable fliser:</strong> Drænende belægninger der lader regnvand nedsive naturligt.</li>
      </ul>

      <h2><strong>Få et uforpligtende tilbud</strong></h2>
      <p>Vi dækker Brønderslev, Hjørring, Aalborg og resten af Nordjylland. Ring til os på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller send en e-mail til <a href="mailto:info@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">info@cmsnord.dk</a> for rådgivning og et uforpligtende prisoverslag.</p>
    `,
    metaTitle: "Belægnings arbejde & Brolægger i Brønderslev - CMSNord.dk",
    metaDescription: "Professionelt belægningsarbejde, fliselægning, indkørsler og terrasser i Brønderslev, Hjørring og Aalborg."
  },
  {
    id: "anlaegsgartner",
    slug: "anlaegsgartner",
    title: "Anlægning af have",
    category: "Belægning & Have",
    iconClass: "fa-solid fa-seedling",
    shortDesc: "Lad os hjælpe dig med at omdanne din have, uanset hvilke krav du har. Professionel haveservice og anlægning i Brønderslev & Nordjylland.",
    primaryImage: "",
    gallerySlug: "anlaegsarbejde",
    body: `
      <h2><strong>Anlægning af have i Brønderslev</strong></h2>
      <p>Lad os hjælpe dig med at omdanne din have, uanset hvilke krav du har. Vi er din dedikerede samarbejdspartner, der leverer professionel haveservice med målet om at forvandle din have til et sundt og smukt udendørsområde. Vores tilgang går ud over almindelig græsslåning og beskæring – vi skaber en forlængelse af dit hjem, der er indbydende og funktionel.</p>

      <h2><strong>Professionel haveservice & anlæg</strong></h2>
      <p>Hos CMSNord leverer vi professionel haveservice i Brønderslev og det meste af Nordjylland. Befinder du dig i nærtliggende byer som Hjørring, Aalborg, Dronninglund eller Vraa, hører vi meget gerne fra dig.</p>

      <h2><strong>Vores haveservice fremmer din have</strong></h2>
      <p>Vedligeholdelse og gennemtænkt anlægsarbejde er essentielt for en sund have året rundt. Vi står blandt andet klar med:</p>
      <ul>
        <li><strong>Etablering af græsplæner:</strong> Nysåning, grubning og udlægning af rullegræs for et hurtigt og tæt grønt tæppe.</li>
        <li><strong>Plantning og bede:</strong> Valg og plantning af buske, hække, træer og stauder tilpasset jordtypen.</li>
        <li><strong>Beskæring og oprydning:</strong> Foryngelse af buskadser, hækklipning og klargøring til forår eller vinter.</li>
        <li><strong>Trampolin-nedgravning:</strong> Sikker og diskret integrering af trampoliner i niveau med græsplænen.</li>
      </ul>

      <h2><strong>Gravearbejde og jordforberedelse</strong></h2>
      <p>Korrekt jordforberedelse er afgørende for et succesfuldt resultat. Vi udfører jordarbejde, der omfatter udgravning, jordforbedring med harpet muld, nivellering og komprimering for at skabe det rette fundament.</p>
      <p>I forlængelse af havearbejdet klarer vi også belægningsarbejde som terrasser, gangstier og støttemure i én samlet løsning.</p>

      <h2><strong>Få et uforpligtende tilbud i dag</strong></h2>
      <p>Uanset om du ønsker et nyt haveanlæg, totalrenovering af grunden eller løbende hjælp til haven, står vi klar. Ring til os på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller send en e-mail til <a href="mailto:kontakt@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">kontakt@cmsnord.dk</a>.</p>
    `,
    metaTitle: "Anlægning af have & Haveservice i Brønderslev - CMSNord.dk",
    metaDescription: "Anlægning af have, græsplæne, rullegræs, plantning og professionel haveservice i Brønderslev, Hjørring og Aalborg."
  },
  {
    id: "belaegning-have",
    slug: "belaegning-have",
    title: "Belægning & Have",
    category: "Belægning & Have",
    iconClass: "fa-solid fa-tree",
    shortDesc: "Vi er din dedikerede havemand, der leverer professionel haveservice med målet om at forvandle din have til et sundt og smukt udendørsområde.",
    primaryImage: "",
    gallerySlug: "haveservice",
    body: `
      <h2><strong>Din partner til Belægning & Have i Brønderslev</strong></h2>
      <p>Vi er din dedikerede partner til professionelt have- og anlægsarbejde i Brønderslev og hele Nordjylland. Uanset om du ønsker etableret nye flisearealer, anlagt en flot græsplæne, ryddet en tilgroet grund eller nedgravet en trampolin, leverer vi kvalitetsarbejde med egne maskiner.</p>

      <h2><strong>Ydelser inden for Belægning & Have</strong></h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 my-6 not-prose">
        <a href="/ydelser/belaegning" class="group block bg-zinc-50 hover:bg-white border border-zinc-200 hover:border-[#F4AF00] p-5 rounded-xl transition-all shadow-sm">
          <h3 class="text-[#121212] font-bold text-base mb-1 group-hover:text-[#F4AF00] transition-colors flex items-center justify-between">
            <span>Belægnings arbejde</span>
            <i class="fa-solid fa-arrow-right text-xs text-zinc-400 group-hover:text-[#F4AF00]"></i>
          </h3>
          <p class="text-zinc-600 text-xs leading-relaxed">Flisebelægning af indkørsler, terrasser, gangstier og støttemure i høj kvalitet.</p>
        </a>

        <a href="/ydelser/anlaegsgartner" class="group block bg-zinc-50 hover:bg-white border border-zinc-200 hover:border-[#F4AF00] p-5 rounded-xl transition-all shadow-sm">
          <h3 class="text-[#121212] font-bold text-base mb-1 group-hover:text-[#F4AF00] transition-colors flex items-center justify-between">
            <span>Anlægning af have</span>
            <i class="fa-solid fa-arrow-right text-xs text-zinc-400 group-hover:text-[#F4AF00]"></i>
          </h3>
          <p class="text-zinc-600 text-xs leading-relaxed">Nyanlæg, rullegræs, såning, beplantning, hækklipning og jordforbedring.</p>
        </a>

        <a href="/ydelser/total-rydning-af-haver" class="group block bg-zinc-50 hover:bg-white border border-zinc-200 hover:border-[#F4AF00] p-5 rounded-xl transition-all shadow-sm">
          <h3 class="text-[#121212] font-bold text-base mb-1 group-hover:text-[#F4AF00] transition-colors flex items-center justify-between">
            <span>Rydning af have</span>
            <i class="fa-solid fa-arrow-right text-xs text-zinc-400 group-hover:text-[#F4AF00]"></i>
          </h3>
          <p class="text-zinc-600 text-xs leading-relaxed">Total rydning af haver, opgravning af rødder, buske og komplet bortkørsel.</p>
        </a>

        <a href="/ydelser/trampolin-nedgravning" class="group block bg-zinc-50 hover:bg-white border border-zinc-200 hover:border-[#F4AF00] p-5 rounded-xl transition-all shadow-sm">
          <h3 class="text-[#121212] font-bold text-base mb-1 group-hover:text-[#F4AF00] transition-colors flex items-center justify-between">
            <span>Trampolin nedgravning</span>
            <i class="fa-solid fa-arrow-right text-xs text-zinc-400 group-hover:text-[#F4AF00]"></i>
          </h3>
          <p class="text-zinc-600 text-xs leading-relaxed">Sikker og æstetisk nedgravning af havetrampoliner i niveau med plænen.</p>
        </a>
      </div>

      <h2><strong>Komplet have- og jordarbejde</strong></h2>
      <p>Vi råder over de nødvendige maskiner og faglig viden til at løse både små og store haveprojekter for private og erhverv i bl.a. Brønderslev, Hjørring, Aalborg, Dronninglund og Vrå:</p>
      <ul>
        <li><strong>Belægning & terrasser:</strong> Professionel opbygning af bundsikring og lægning af fliser.</li>
        <li><strong>Jord- og gravearbejde:</strong> Jordnivellering, udgravninger og klargøring til haveanlæg.</li>
        <li><strong>Havepleje & nyanlæg:</strong> Skræddersyede løsninger tilpasset din grund og dine ønsker.</li>
        <li><strong>Bortkørsel:</strong> Vi sørger for miljøvenlig bortskaffelse af rødder, haveaffald og overskudsjord.</li>
      </ul>

      <p>Kontakt os i dag på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller på <a href="mailto:info@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">info@cmsnord.dk</a> for en uforpligtende snak og et godt tilbud på dit haveprojekt.</p>
    `,
    metaTitle: "Din Partner Til Belægning & Have i Brønderslev - CMSNord.dk",
    metaDescription: "Professionel haveservice, haveanlæg, rydning af haver og belægningsarbejde i Brønderslev og Nordjylland."
  },
  {
    id: "total-rydning-af-haver",
    slug: "total-rydning-af-haver",
    title: "Rydning af haver",
    category: "Belægning & Have",
    iconClass: "fa-solid fa-tree",
    shortDesc: "Vi leverer total rydning af haver, både for det private og i erhverv. Opgravning af rødder, buskfældning og komplet bortskaffelse i Nordjylland.",
    primaryImage: "",
    gallerySlug: "anlaegsarbejde",
    body: `
      <h2><strong>Rydning af have for private og erhverv</strong></h2>
      <p>Vi leverer total rydning af haver, både for private haveejere og for virksomheder/boligselskaber. Har haven fået lov til at gro til, eller skal der gøres plads til et nyt byggeprojekt eller en komplet haveomlægning? Med vores moderne maskinpark af minigravere, minilæssere og containere klarer vi hele rydningsprocessen effektivt og skånsomt.</p>

      <h2><strong>Hvad indebærer total rydning af haver?</strong></h2>
      <p>Når vi rydder en have, fjerner vi uønsket bevoksning og gør jorden klar til det næste kapitel:</p>
      <ul>
        <li><strong>Opgravning af trærødder og stød:</strong> Vi graver rødderne helt fri med minigraver, så de ikke skyder igen eller ødelægger fremtidig belægning.</li>
        <li><strong>Fjernelse af gamle hække, buske og krat:</strong> Effektiv maskinel nedskæring og opgravning.</li>
        <li><strong>Afgravning af gammel græstørv og ukrudt:</strong> Fjerner det øverste lag for at give plads til frisk harpet muld eller stabilgrus.</li>
        <li><strong>Planering og nivellering:</strong> Grov- og finplanering af arealet, så det er klar til nysåning, rullegræs eller fliselægning.</li>
        <li><strong>Komplet bortkørsel:</strong> Vi sørger for miljørigtig bortkørsel af alle haveaffalds- og rodmasser med egne containere.</li>
      </ul>

      <h2><strong>Fordele ved at lade CMSNord stå for rydningen</strong></h2>
      <ul>
        <li><strong>Egne maskiner og udstyr:</strong> Hurtig og skånsom udførelse uden unødig ventetid eller lejeomkostninger.</li>
        <li><strong>Alt-i-én løsning:</strong> Fra opgravning til komplet bortskaffelse og planering.</li>
        <li><strong>Fleksibilitet og hurtig respons:</strong> Vi rykker ud i hele Vendsyssel, Aalborg og Brønderslev.</li>
      </ul>

      <h2><strong>Få et uforpligtende tilbud på rydning</strong></h2>
      <p>Kontakt os på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller på <a href="mailto:kontakt@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">kontakt@cmsnord.dk</a>, så kigger vi forbi og giver en god fast pris på rydningen af din have.</p>
    `,
    metaTitle: "Rydning af Have i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Professionel total rydning af haver, opgravning af rødder, buske og bortkørsel af haveaffald for private og erhverv i Brønderslev."
  },
  {
    id: "trampolin-nedgravning",
    slug: "trampolin-nedgravning",
    title: "Trampolin nedgravning",
    category: "Belægning & Have",
    iconClass: "fa-solid fa-circle-dot",
    shortDesc: "Med en nedgravet trampolin, kan du både opnå sikkerhed og æstetik. Præcis og professionel nedgravning til konkurrencedygtige priser.",
    primaryImage: "",
    gallerySlug: "jordarbejde",
    body: `
      <h2><strong>Trampolin nedgravning med fokus på sikkerhed & æstetik</strong></h2>
      <p>Vi tilbyder professionel trampolin-nedgravning for en sikrere og smukkere have. Vores erfarne hold sikrer præcis og æstetisk nedgravning til konkurrencedygtige priser. Vi fokuserer på sikkerhed, pålidelighed og holdbarhed.</p>

      <h2><strong>Hvorfor vælge en nedgravet trampolin?</strong></h2>
      <p>Mangler du hjælp til nedgravningsopgaver, så der kan blive plads til en trampolin i din have, klarer vi udgravningen med vores minigravere. En nedgravet trampolin giver et meget sikrere legemiljø for børnene og skaber samtidig en rolig, ryddelig have uden store stel, der tager udsigten.</p>

      <h2><strong>Præcis og professionel udførelse</strong></h2>
      <p>Vi tager højde for jordbundens forhold, korrekt dybde, luftcirkulation og drænforhold. Vores fokusområder:</p>
      <ul>
        <li><strong>Præcis udgravning med minigraver:</strong> Passer millimeterpræcist til trampolinens diameter og facon.</li>
        <li><strong>Konkurrencedygtige priser:</strong> Faste priser på selve udgravningen, bortskaffelsen og eventuel montering.</li>
        <li><strong>Hurtig og renlig udførelse:</strong> Vi efterlader haven pæn og ryddelig.</li>
        <li><strong>Skønhed og sikkerhed i ét:</strong> Trampolinen integreres plant med græsplænen.</li>
      </ul>

      <h2><strong>Prisoversigt på trampolin nedgravning</strong></h2>
      <div class="overflow-x-auto my-6 not-prose">
        <table class="w-full text-left border-collapse border border-zinc-200 bg-white rounded-xl overflow-hidden shadow-sm">
          <thead>
            <tr class="bg-zinc-100 text-[#121212] border-b border-zinc-200">
              <th class="p-3.5 font-bold text-sm">Ydelse</th>
              <th class="p-3.5 font-bold text-sm">Pris</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-zinc-100 text-zinc-700 text-sm">
            <tr class="hover:bg-zinc-50 transition-colors">
              <td class="p-3.5 font-medium text-[#121212]">* Trampolin nedgravning</td>
              <td class="p-3.5 font-bold text-[#121212]">Fra 1.999 kr.</td>
            </tr>
            <tr class="hover:bg-zinc-50 transition-colors">
              <td class="p-3.5 font-medium text-[#121212]">** Bortskaffelse af overskudsjord</td>
              <td class="p-3.5 font-bold text-[#121212]">Fra 1.899 kr.</td>
            </tr>
            <tr class="hover:bg-zinc-50 transition-colors">
              <td class="p-3.5 font-medium text-[#121212]">Montering af trampolin</td>
              <td class="p-3.5 font-bold text-[#121212]">Fra 399 kr.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-xs text-zinc-500 leading-relaxed italic">
        Minimumsadgangsforhold: 100 cm bredde / 220 cm højde.<br/>
        * I en radius af 30 km fra Brønderslev (herudover tilkommer mindre kørselstillæg).<br/>
        ** Inkl. transport og afgravning af jord (ekskl. evt. deponiafgift).
      </p>

      <h2><strong>Kontakt os for bestilling</strong></h2>
      <p>Ring til os på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller send en e-mail til <a href="mailto:kontakt@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">kontakt@cmsnord.dk</a> for at aftale tid til nedgravning af din trampolin.</p>
    `,
    metaTitle: "Trampolin Nedgravning i Brønderslev - CMSNord.dk",
    metaDescription: "Professionel trampolin-nedgravning til konkurrencedygtige priser. Skab en sikrere og smukkere have med Christians Maskin Service."
  },
  {
    id: "materialelevering",
    slug: "materialelevering",
    title: "Levering af sand, grus og muld",
    category: "Vognmandskørsel",
    iconClass: "fa-solid fa-truck-ramp-box",
    shortDesc: "Vi leverer høj kvalitet sand, grus og muld direkte til din dør, perfekt til bygge- og haveprojekter.",
    primaryImage: "",
    gallerySlug: "vognmandskoersel",
    body: `
      <p class="text-base sm:text-lg text-zinc-700 leading-relaxed font-normal">
        Vi leverer høj kvalitet sand, grus og muld direkte til din dør, perfekt til bygge- og haveprojekter. Vores udvalg opfylder de højeste standarder og kan tilpasses dine behov. Christians Maskin Service er din pålidelige kilde til kvalitetsmaterialer med konkurrencedygtige priser og pålidelig levering. Vi er klar til at hjælpe med dine materialebehov.
      </p>
      
      <p class="text-zinc-600">
        Mangler du levering af sand, grus og muld, står vi til rådighed, og er klar til at hjælpe dig. Vi forstår, at kvalitetsmaterialer er afgørende for vellykkede bygge- og haveprojekter, og vi er her for at levere dem sikkert og rettidigt til dig.
      </p>

      <h2><strong>Materialer til ethvert behov</strong></h2>
      <p>Vi tilbyder et bredt udvalg af materialer, herunder sand, grus og muld. Uanset om du har brug for materialer til anlægsarbejde, haveprojekter eller jordforbedring, leverer vi dem direkte til din dør. Få blandt andet følgende hos os:</p>

      <ul class="space-y-1.5 my-4">
        <li><strong>Kvalitetsmaterialer:</strong> Certificerede og rene råstoffer til ethvert bygge- og anlægsformål.</li>
        <li><strong>Konkurrencedygtige priser:</strong> Gode mængdepriser og faste, gennemskuelige leveringspriser.</li>
        <li><strong>Pålidelig levering:</strong> Punktlig levering direkte til det aftalte sted.</li>
        <li><strong>Skræddersyede mængder:</strong> Fleksible mængder til både mindre haveopgaver og store projekter.</li>
      </ul>

      <p>Lad Christians Maskin Service være din pålidelige kilde til materialer. Vi sikrer, at du får det, du har brug for, til dit projekt. Står det materiale som du skal bruge ikke på listen, så ring endelig ind, eller send en forespørgsel på det materiale samt mængden.</p>

      <h2><strong>Materiale liste</strong></h2>
      <ul class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-2.5 my-4 bg-zinc-50 border border-zinc-200 rounded-xl p-5 sm:p-6 shadow-xs">
        <li class="font-medium text-zinc-800">Fyldsand</li>
        <li class="font-medium text-zinc-800">Bundsikringssand</li>
        <li class="font-medium text-zinc-800">Flisesand 0-4</li>
        <li class="font-medium text-zinc-800">Støbesand 0-4</li>
        <li class="font-medium text-zinc-800">Ridebanesand</li>
        <li class="font-medium text-zinc-800">Vejgrus 0-20</li>
        <li class="font-medium text-zinc-800">Vejgrus 0-32</li>
        <li class="font-medium text-zinc-800">Stabilgrus</li>
        <li class="font-medium text-zinc-800">Støbemix 0-8</li>
        <li class="font-medium text-zinc-800">Støbemix 0-16</li>
        <li class="font-medium text-zinc-800">Knust tegl</li>
        <li class="font-medium text-zinc-800">Knust beton</li>
        <li class="font-medium text-zinc-800">Knust asfalt</li>
        <li class="font-medium text-zinc-800">Uharpet muld</li>
        <li class="font-medium text-zinc-800">Harpet muld</li>
        <li class="font-medium text-zinc-800">Granit skærver (div. str. og farver)</li>
        <li class="font-medium text-zinc-800">Stenmel</li>
      </ul>

      <p class="text-xs sm:text-sm text-zinc-500 italic mt-2 mb-6">
        * Står det du skal bruge ikke på listen, så send endelig en forespørgsel.
      </p>

      <div class="not-prose bg-zinc-900 text-white rounded-xl p-6 sm:p-7 border border-zinc-800 my-6 shadow-sm">
        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div class="inline-flex items-center gap-2 bg-[#F4AF00]/20 text-[#F4AF00] text-xs font-bold px-2.5 py-1 rounded-full mb-2">
              <i class="fa-solid fa-dolly"></i>
              <span>Trange adgangsforhold?</span>
            </div>
            <h4 class="text-lg font-bold text-white m-0">Maskiner & Udstyr til svære adgangsveje</h4>
            <p class="text-xs sm:text-sm text-zinc-300 mt-1 max-w-xl">
              Skal leverancen ind, hvor der ikke er plads til en lastbil? Vi kan være behjælpelige med leje af minilæsser eller motorbør – eller klare hele indkørslen for dig.
            </p>
          </div>
        </div>
      </div>

      <h2><strong>Kontakt os for bestilling</strong></h2>
      <p>
        Ring til os på <a href="tel:25623505" class="text-zinc-900 font-bold hover:underline">25 62 35 05</a> eller send en e-mail til <a href="mailto:kontakt@cmsnord.dk" class="text-zinc-900 font-bold hover:underline">kontakt@cmsnord.dk</a> for at bestille dine materialer eller få et uforpligtende tilbud på levering. Vi er altid klar til at hjælpe dig godt i gang med dit projekt!
      </p>
    `,
    metaTitle: "Levering af Sand, Grus og Muld i Nordjylland - CMSNord.dk",
    metaDescription: "Vi leverer høj kvalitet sand, grus og muld direkte til din dør i Brønderslev og hele Nordjylland. Konkurrencedygtige priser og pålidelig levering."
  },
  {
    id: "vognmand",
    slug: "vognmand",
    title: "Vognmandskørsel",
    category: "Vognmandskørsel",
    iconClass: "fa-solid fa-truck-front",
    shortDesc: "Levering af råstoffer og materialer samt transport af jord, affald og maskiner.",
    primaryImage: "",
    gallerySlug: "vognmandskoersel",
    body: `
      <h2><strong>Din vognmand i Brønderslev, Hjørring & Aalborg</strong></h2>
      <p>Vi er din pålidelige vognmand i Brønderslev og Nordjylland, herunder Aalborg og Hjørring. Vi specialiserer os i vognmandstjenester, herunder jordbortkørsel, levering af materialer som grus og sand, samt containerudlejning. Med års erfaring og ekspertise garanterer vi professionalisme, kvalitet og pålidelighed. Vores erfarne chauffører og eget udstyr sikrer sikker transport og håndtering af materialer.</p>

      <h2><strong>Vognmandskørsel i Brønderslev</strong></h2>
      <p>En vognmand spiller i dag en afgørende rolle i mange forskellige brancher, især når det kommer til sektorer der har med byggeprojekter at gøre. Hos os forstår vi betydningen af pålidelige vognmandstjenester. Som professionel vognmand i Brønderslev og Nordjylland er vores mål at sikre, at dine transportbehov bliver opfyldt fuldt ud.</p>
      <p>Sikkerheden for vores kunder og lasten vi transporterer, er i vores øverste prioritet. Vores chauffører overholder alle sikkerhedsprocedurer, og vi benytter vores egne maskiner, lastbiler og containere – du har derfor ikke brug for andre mellemmænd, når du samarbejder med os.</p>

      <h2><strong>Vores vognmandstjenester</strong></h2>
      <ul>
        <li><strong>Bortskaffelse af overskydende jord:</strong> Jorden kan være en udfordrende opgave, men vi har det nødvendige udstyr og containere til at håndtere bortkørslen hurtigt.</li>
        <li><strong>Levering af grus, sand og muld:</strong> Afgørende materialer i bygge- og anlægsbranchen. Vi leverer råstoffer i topkvalitet direkte til adressen.</li>
        <li><strong>Containerudlejning:</strong> Til byggepladsen, renovering eller affaldshåndtering. Vi har enheder i forskellige størrelser.</li>
        <li><strong>Maskintransport & kørsel:</strong> Sikker flytning af entreprenørmaskiner og redskaber.</li>
      </ul>

      <h2><strong>Hvorfor vælge os som din vognmand?</strong></h2>
      <ul>
        <li><strong>Erfaring:</strong> Vi har været en aktør som vognmand i lang tid, hvilket har forberedt os på enhver opgave.</li>
        <li><strong>Pålidelighed og kvalitet:</strong> Vi opretholder dine forventninger, overholder tidsfrister og leverer de bedste resultater.</li>
        <li><strong>Ekspertise:</strong> Dygtige chauffører, der er klar til at håndtere forskellige typer af materialer og gods sikkert.</li>
      </ul>
    `,
    metaTitle: "Vognmandskørsel i Brønderslev, Hjørring & Aalborg - CMSNord.dk",
    metaDescription: "Pålidelig vognmandskørsel, levering af grus, sand og muld samt jordbortkørsel i hele Nordjylland."
  },
  {
    id: "containerudlejning",
    slug: "containerudlejning",
    title: "Containerudlejning",
    category: "Vognmandskørsel",
    iconClass: "fa-solid fa-box-archive",
    shortDesc: "Udlejning af containere i Brønderslev og Nordjylland. Hurtig levering og afhentning til bygge- og haveaffald.",
    primaryImage: "",
    gallerySlug: "containerudlejning",
    body: `
      <p>Lej professionelle containere hos Christians Maskin Service til byggepladsen, renovering eller affaldshåndtering. Vælg fra vores flåde af forskellige enheder. Vi tilbyder konkurrencedygtige priser. Vi leverer og henter efter aftale, så du kan fokusere på din opgave.</p>
      <p>Lad os sikre, at din næste opgave forløber problemfrit med den bedste service til den rette pris.</p>

      <h2><strong>Lej din container her</strong></h2>
      <p>Christians Maskin Service tilbyder professionel containerudlejning til alle typer firmaer. Uanset om du har brug for en container til byggepladsen, renovering, eller affaldshåndtering, har vi den rette løsning til dig.</p>

      <h2><strong>Fleksible løsninger</strong></h2>
      <p>Vores flåde af containere spænder fra forskellige enheder, til små containere til mellem og store containere. Vi tilbyder et udvalg af åbne containere, så du kan vælge den, der passer bedst til dine behov.</p>
      <p>Vi leverer og henter efter aftale, så du kan fokusere på din opgave, mens vi tager os af affaldet.</p>
      <p>Vi tilbyder konkurrencedygtige priser på containerudlejning, der passer til ethvert budget.</p>
    `,
    metaTitle: "Containerudlejning i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Lej en container til haveaffald, murbrokker eller byggeaffald i Brønderslev. Hurtig levering og afhentning."
  },
  {
    id: "bortskaffelse",
    slug: "bortskaffelse",
    title: "Bortskaffelse",
    category: "Vognmandskørsel",
    iconClass: "fa-solid fa-recycle",
    shortDesc: "Effektiv bortkørsel og miljøvenlig bortskaffelse af jord, haveaffald, brokker og byggematerialer i Nordjylland.",
    primaryImage: "",
    gallerySlug: "vognmandskoersel",
    body: `
      <p>Christians Maskin Service er din Nordjyske partner for effektiv bortkørsel og miljøvenlig bortskaffelse af jord, haveaffald, brokker, byggematerialer og meget mere. Vores erfarne team sørger for hurtig og pålidelig service, til konkurrencedygtige priser, og din tilfredshed er vores prioritet.</p>
      
      <p>Få ansvarlig håndtering af dit restaffald og materialer, så du kan fokusere på dit projekt med tryghed om korrekt materiale- og affaldshåndtering. Christians Maskin Service er din partner for bortkørsel og bortskaffelse af jord eller mange som helst andre materialer i Nordjylland. Uanset om du står over for overskydende jord fra haveprojekter, haveaffald, jord eller byggematerialer fra et byggeri eller en renovering, er vi specialister i at hjælpe dig med at fjerne og håndtere materialerne professionelt.</p>
      
      <p>Giv os et kald på <a href="tel:25623505" class="text-[#F4AF00] font-bold hover:underline">25 62 35 05</a> eller send en e-mail til <a href="mailto:kontakt@cmsnord.dk" class="text-[#F4AF00] font-bold hover:underline">kontakt@cmsnord.dk</a>. Start processen med at bortskaffe dine restmaterialer på en ansvarlig måde ved at kontakte Christians Maskin Service.</p>

      <h2><strong>Effektiv Bortskaffelse</strong></h2>
      <p>Vores erfarne team sørger for hurtig og effektiv fjernelse af jord fra din ejendom. Vi besidder den nødvendige udstyr og knowhow for at håndtere jordaffald på en miljøvenlig måde. Udover jord byder vi på bortskaffelse af langt det meste restaffald fra diverse byggeprojekter.</p>
      <p>Om du har overskydende jord, haveaffald, brokker som mur- og teglbrokker, byggematerialer, jern og diverse andre materialer, så kan vi hjælpe dig. Er du i nogen som helst tvivl om hvad vi kan håndtere, er du altid velkommen til at kontakte os. Vi tager os af de fleste opgaver, og er klar til at hjælpe dig.</p>

      <h2><strong>Hvorfor vælge os?</strong></h2>
      <ul>
        <li><strong>Sikker og miljøvenlig afskaffelse:</strong> Jord, haveaffald, murbrokker, beton, byggematerialer og jern.</li>
        <li><strong>Konkurrencedygtige priser:</strong> Faste aftaler uden uventede gebyrer.</li>
        <li><strong>Fleksibel og pålidelig service:</strong> Vi henter og afleverer til tiden.</li>
        <li><strong>Kundetilfredshed i højsædet:</strong> Vi efterlader arbejdspladsen ryddelig og pæn.</li>
      </ul>
      <p class="mt-4">Vi tager ansvaret for bortkørsel og bortskaffelse af dit restaffald efter dine diverse bygge- og haveprojekter, så du kan fokusere på dit projekt, velvidende at restaffald og materialerne håndteres korrekt.</p>
    `,
    metaTitle: "Bortskaffelse & Bortkørsel i Brønderslev & Nordjylland - CMSNord.dk",
    metaDescription: "Effektiv bortkørsel og miljøvenlig bortskaffelse af jord, haveaffald, murbrokker og byggematerialer i Nordjylland."
  }
];

export const MAIN_GALLERIES = [
  {
    id: "entreprenoer",
    title: "Entreprenør",
    slug: "entreprenoer",
    icon: "fa-solid fa-trowel-bricks",
    description: "Udgravning, jordarbejde, terrænregulering og nedbrydningsopgaver.",
    coverImage: "",
    subCategoryIds: [
      "jord-gravearbejde",
      "nedbrydning",
      "trampolin-nedgravning",
      "jordarbejde"
    ]
  },
  {
    id: "belaegning",
    title: "Belægning",
    slug: "belaegning",
    icon: "fa-solid fa-cubes",
    description: "Flisebelægning, terrasser, indkørsler, gangstier og brolægning.",
    coverImage: "",
    subCategoryIds: [
      "belaegning",
      "flisebelaegning",
      "terrasser-stier"
    ]
  },
  {
    id: "have",
    title: "Have",
    slug: "have",
    icon: "fa-solid fa-seedling",
    description: "Haveanlæg, anlægsgartner, total rydning af haver og haveservice.",
    coverImage: "",
    subCategoryIds: [
      "total-rydning-af-haver",
      "anlaegsgartner",
      "haveservice",
      "anlaegsarbejde"
    ]
  },
  {
    id: "vognmand",
    title: "Vognmandskørsel",
    slug: "vognmand",
    icon: "fa-solid fa-truck-front",
    description: "Vognmandskørsel, materialetransport og containerudlejning.",
    coverImage: "",
    subCategoryIds: [
      "bortskaffelse",
      "vognmandskoersel",
      "containerudlejning"
    ]
  }
];

export const GALLERY_CATEGORIES = [
  {
    id: "jordarbejde",
    title: "Jord- & Gravearbejde",
    slug: "jordarbejde",
    coverImage: "",
    description: "Udgravning, terrænregulering, kabelgrave og professionelt jordarbejde.",
    images: []
  },
  {
    id: "haveservice",
    title: "Haveservice",
    slug: "haveservice",
    coverImage: "",
    description: "Total rydning af haver, opgravning af rødder, buskrydning og bortkørsel.",
    images: []
  },
  {
    id: "vognmandskoersel",
    title: "Vognmandskørsel",
    slug: "vognmandskoersel",
    coverImage: "",
    description: "Transport af grus, sand, jord, materialer og maskintransport i Nordjylland.",
    images: []
  },
  {
    id: "nedbrydning",
    title: "Nedbrydning",
    slug: "nedbrydning",
    coverImage: "",
    description: "Sikker nedbrydning af skure, garager, betonlag, sokler og mindre bygninger.",
    images: []
  },
  {
    id: "foer-efter",
    title: "Se før/efter",
    slug: "foer-efter",
    coverImage: "",
    description: "Se den markante forskel før og efter vores udførte arbejde i haven og på grunden.",
    images: []
  },
  {
    id: "containerudlejning",
    title: "Containerudlejning",
    slug: "containerudlejning",
    coverImage: "",
    description: "Udlejning af containere til byggeaffald, haveaffald og murbrokker.",
    images: []
  },
  {
    id: "belaegning",
    title: "Belægningsarbejde",
    slug: "belaegning",
    coverImage: "",
    description: "Professionelt anlægsarbejde, haveanlæg, flisebelægning, indkørsler, terrasser, gangstier og støttemure.",
    images: []
  },
  {
    id: "anlaegsarbejde",
    title: "Total rydning af haver",
    slug: "anlaegsarbejde",
    coverImage: "",
    description: "Total rydning af haver, opgravning af rødder, buskrydning og komplet klargøring af grunden.",
    images: []
  },
  {
    id: "opgaver",
    title: "Diverse opgaver & projekter",
    slug: "opgaver",
    coverImage: "",
    description: "Billeder af forskellige entreprenør- og vognmandsopgaver.",
    images: []
  }
];

export const GALLERIES = {
  forside: {
    title: "Udvalgte projekter",
    images: []
  },
  jordarbejde: {
    title: "Billeder fra Jord- & Gravearbejde",
    images: []
  },
  nedbrydning: {
    title: "Billeder fra Nedbrydning",
    images: []
  },
  belaegning: {
    title: "Billeder fra Anlægsarbejde",
    images: []
  },
  anlaegsarbejde: {
    title: "Billeder fra Total rydning af haver",
    images: []
  },
  haveservice: {
    title: "Billeder fra Haveservice",
    images: []
  },
  vognmandskoersel: {
    title: "Billeder fra Vognmandskørsel",
    images: []
  },
  containerudlejning: {
    title: "Billeder fra Containerudlejning",
    images: []
  },
  opgaver: {
    title: "Udvalgte billeder fra vores arbejde",
    images: []
  }
};

export const BEFORE_AFTER_PAIRS = [];

export const TESTIMONIALS = [
  {
    author: "Morten Jensen",
    location: "Brønderslev",
    rating: 5,
    text: "CMSNord lavede vores nye indkørsel og udgravning. Fantastisk stykke arbejde, overholdt tidsplanen og ryddede pænt op bagefter. Kan varmt anbefales!"
  },
  {
    author: "Helle S.",
    location: "Hjørring",
    rating: 5,
    text: "Hurtig levering af sand og container til haveaffald. Meget imødekommende og hjælpsom service fra start til slut."
  },
  {
    author: "Klaus P.",
    location: "Aalborg N",
    rating: 5,
    text: "Fik gravet ud og lagt ny terrasse. Perfekt fald og skarpe linjer. Rigtig dygtig og arbejdsom vognmand og entreprenør."
  }
];
